import { LOGGED_OUT } from 'actions/types';
import { sortAscByStringWithKey } from 'utils/arrayHelpers';
import { AssetStateCache } from '../types';
const initialState = {
    watchListAssetCache: {},
    stockWatchListsInfoMap: {},
};
const watchListReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_WATCHLIST_SUCCESS': {
            const { id, assets } = action.payload.watchlist;
            sortAscByStringWithKey(assets, 'name');
            const stockWatchListsInfoMap = {};
            const assetsWithAssetState = assets.map((asset) => {
                stockWatchListsInfoMap[asset.id] = {
                    ...state.stockWatchListsInfoMap?.[asset.id],
                    [id]: true,
                };
                return {
                    ...asset,
                    state: AssetStateCache.SYNCED,
                };
            });
            return {
                ...state,
                watchListAssetCache: {
                    ...state.watchListAssetCache,
                    [id]: assetsWithAssetState,
                },
                stockWatchListsInfoMap: {
                    ...state.stockWatchListsInfoMap,
                    ...stockWatchListsInfoMap,
                },
            };
        }
        case 'ADD_ASSET_TO_WATCHLIST_REQUEST': {
            const { watchlistId, assetId, name, symbol } = action.extra;
            const watchListAssetCache = state.watchListAssetCache?.[watchlistId] || [];
            const hasAsset = watchListAssetCache.find((cachedAsset) => assetId === cachedAsset.id);
            if (!hasAsset) {
                const newWatchListAssetCache = [
                    ...watchListAssetCache,
                    { symbol, id: assetId, name, state: AssetStateCache.ADDING },
                ];
                sortAscByStringWithKey(newWatchListAssetCache, 'name');
                return {
                    ...state,
                    watchListAssetCache: {
                        ...state.watchListAssetCache,
                        [watchlistId]: newWatchListAssetCache,
                    },
                    stockWatchListsInfoMap: {
                        ...state.stockWatchListsInfoMap,
                        [assetId]: {
                            ...state.stockWatchListsInfoMap?.[assetId],
                            [watchlistId]: true,
                        },
                    },
                };
            }
            return state;
        }
        case 'REMOVE_ASSET_FROM_WATCHLIST_REQUEST': {
            const { watchlistId, assetId } = action.extra;
            const watchListAssetCache = state.watchListAssetCache?.[watchlistId] || [];
            const newWatchListAssetCache = watchListAssetCache.map((cachedAsset) => {
                if (cachedAsset.id === assetId) {
                    return {
                        ...cachedAsset,
                        state: AssetStateCache.REMOVING,
                    };
                }
                return cachedAsset;
            });
            const stockWatchListsInfoMap = state.stockWatchListsInfoMap?.[assetId] || {};
            delete stockWatchListsInfoMap[watchlistId];
            return {
                ...state,
                watchListAssetCache: {
                    ...state.watchListAssetCache,
                    [watchlistId]: newWatchListAssetCache,
                },
                stockWatchListsInfoMap: {
                    ...state.stockWatchListsInfoMap,
                    [assetId]: {
                        ...stockWatchListsInfoMap,
                    },
                },
            };
        }
        case 'ADD_ASSET_TO_WATCHLIST_ERROR': {
            const { watchlistId, assetId } = action.extra;
            const watchListAssetCache = state.watchListAssetCache?.[watchlistId] || [];
            const newWatchListAssetCache = watchListAssetCache.filter((cachedAsset) => cachedAsset.id !== assetId);
            const stockWatchListsInfoMap = state.stockWatchListsInfoMap?.[assetId] || {};
            delete stockWatchListsInfoMap[watchlistId];
            return {
                ...state,
                watchListAssetCache: {
                    ...state.watchListAssetCache,
                    [watchlistId]: newWatchListAssetCache,
                },
                stockWatchListsInfoMap: {
                    ...state.stockWatchListsInfoMap,
                    [assetId]: {
                        ...stockWatchListsInfoMap,
                    },
                },
            };
        }
        case 'REMOVE_ASSET_FROM_WATCHLIST_ERROR': {
            const { watchlistId, assetId } = action.extra;
            const watchListAssetCache = state.watchListAssetCache?.[watchlistId] || [];
            const newWatchListAssetCache = watchListAssetCache.map((cachedAsset) => {
                if (cachedAsset.id === assetId) {
                    return {
                        ...cachedAsset,
                        state: AssetStateCache.SYNCED,
                    };
                }
                return cachedAsset;
            });
            return {
                ...state,
                watchListAssetCache: {
                    ...state.watchListAssetCache,
                    [watchlistId]: newWatchListAssetCache,
                },
                stockWatchListsInfoMap: {
                    ...state.stockWatchListsInfoMap,
                    [assetId]: {
                        ...state.stockWatchListsInfoMap?.[assetId],
                        [watchlistId]: true,
                    },
                },
            };
        }
        case 'ADD_ASSET_TO_WATCHLIST_SUCCESS': {
            const { extra: { assetId }, payload: { watchlist: { id, assets }, }, } = action;
            const watchListAssetCache = state.watchListAssetCache?.[id] || [];
            const newAddedAsset = assets.find((asset) => asset.id === assetId);
            let newWatchListAssetCache;
            if (newAddedAsset) {
                let hasAsset = false;
                newWatchListAssetCache = watchListAssetCache.map((cachedAsset) => {
                    if (cachedAsset.id !== assetId) {
                        return cachedAsset;
                    }
                    hasAsset = true;
                    return {
                        ...newAddedAsset,
                        state: AssetStateCache.SYNCED,
                    };
                });
                if (!hasAsset) {
                    newWatchListAssetCache.push({
                        ...newAddedAsset,
                        state: AssetStateCache.SYNCED,
                    });
                }
                sortAscByStringWithKey(newWatchListAssetCache, 'name');
            }
            else {
                newWatchListAssetCache = watchListAssetCache;
            }
            return {
                ...state,
                watchListAssetCache: {
                    ...state.watchListAssetCache,
                    [id]: newWatchListAssetCache,
                },
            };
        }
        case 'REMOVE_ASSET_FROM_WATCHLIST_SUCCESS': {
            const { extra: { assetId }, payload: { watchlist: { id }, }, } = action;
            const watchListAssetCache = state.watchListAssetCache?.[id] || [];
            const newWatchListAssetCache = watchListAssetCache.filter((asset) => asset.id !== assetId);
            return {
                ...state,
                watchListAssetCache: {
                    ...state.watchListAssetCache,
                    [id]: newWatchListAssetCache,
                },
            };
        }
        case 'GET_WATCHLIST_OF_STOCK_SUCCESS': {
            const { assetId, payload: { watchlistIds }, } = action;
            const assetIdWatchListInfo = {};
            watchlistIds.forEach((watchListId) => {
                assetIdWatchListInfo[watchListId] = true;
            });
            return {
                ...state,
                stockWatchListsInfoMap: {
                    ...state.stockWatchListsInfoMap,
                    [assetId]: assetIdWatchListInfo,
                },
            };
        }
        case LOGGED_OUT: {
            return initialState;
        }
        default:
            return state;
    }
};
export default watchListReducer;
